<template>
    <!-- 顶部信息区域  -->
    <div :class="{'daily-product':true,'raderproduct':type == 20, 'dailyProductDark': isDark}">
        <div :class="{'inte-back':true,'not-inte':type != 20}"></div>
        <div class="daily-desc">{{dailyMap[type + '']}}介绍：{{info.description}}</div>
        <template v-if="type == 20">
                <div class="focus">
                    <ul>
                        <li>
                            <div class="card">
                                <div class="rader3"></div>
                                <div class="content">
                                    <p class="title">覆盖全球 实时更新</p>
                                    <p class="desc">覆盖全球各大足、篮球赛事，每日实时捕捉最新重要信息</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card">
                                <div class="rader1"></div>
                                <div class="content">
                                    <p class="title">历史纪录 透视比赛</p>
                                    <p class="desc">搜集当日全球参赛球队、球员各类对比赛有参考价值的历史纪录</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card">
                                <div class="rader2"></div>
                                <div class="content">
                                    <p class="title">极限数据 规律总结</p>
                                    <p class="desc">精选对比赛有影响的极限数据，包含胜负、大小球、指数等多个维度</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card">
                                <div class="rader3"></div>
                                <div class="content">
                                    <p class="title">覆盖全球 实时更新</p>
                                    <p class="desc">覆盖全球各大足、篮球赛事，每日实时捕捉最新重要信息</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card">
                                <div class="rader1"></div>
                                <div class="content">
                                    <p class="title">历史纪录 透视比赛</p>
                                    <p class="desc">搜集当日全球参赛球队、球员各类对比赛有参考价值的历史纪录</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <ol>
                        <li class="current"></li>
                        <li></li>
                        <li></li>
                    </ol>
            </div>
        </template>
        <!-- 购买人数 -->
        <div :class="{'daily-user-buy':true, 'none':buyInfo.total == '0' || isHiscoress()}">
            <span class="user-num">共{{buyInfo.total}}人购买</span>
            <template v-if="buyInfo.avatar && buyInfo.avatar.length > 0">
                <span v-for="(item,index) in buyInfo.avatar" :key="index" class="face"><img :src="item" /></span>
            </template>
        </div>
        <!-- 有效期 status 0未购买 -1未登录 3已过期 1已购买 -->
        <div :class="{'daily-buy':true, 'gofollowservice':type == 20 && (info.status == 1 || info.status == 2)}">
            <template v-if="info && info.name">
                <!-- 没有权限 -->
                <template v-if="info.status == 0 || info.status == -1 || info.status == 3">
                    <template v-if="behavior == 1 && info.status == 0">
                        <span class="tags-expired">查看权限派发中，轻点查询按钮可进行刷新</span>
                    </template>
                    <template v-else>
                        <span class="tags-expired">{{info.tags}}</span>
                    </template>
                    <template v-if="(type != 6 || type != 2 || type != 3 || type != 4 || type != 1)">
                        <template v-if=" (isStorepacks() && (getAppVs() == 293))">
                            <div></div>
                        </template>
                        <template v-else-if="behavior == 1 && info.status == 0">
                            <span :class="{'daily-renew':true}">查询</span>
                        </template>
                        <template v-else>
                            <span :class="{'daily-renew':true,'buyinte':type == 20}" @click="goPay(false)">{{dataPrice[type]}}{{isStorepacks() ? '元' : '嗨币'}}/月</span>
                        </template>
                    </template>
                </template>
                <!-- 有权限 -->
                <template v-else>
                    <template>
                        <span class="time-expired">有效期至：{{info.end_time && info.end_time.substring(0,10)}}{{diffDay()}}</span>
                    </template>
                    <template v-if="(!(isStorepacks() && getAppVs() == 293)) && (type != 2 && type != 3 && type != 4 && type != 1)">
                        <span :class="{'daily-renew':true,'isinte':type == 20 && (info.status == 1 || info.status == 2) && !isHiscoress(),'ishiscores':isHiscoress()}" @click="goPay(true)">续 费</span>
                    </template>
                    <div v-if="type == 20 && (info.status == 1 || info.status == 2) && !isHiscoress()" class="gotoservicehouse" @click="goFollowServiceHouse">关注服务号</div>
                </template>
            </template>
        </div>
        <van-dialog v-model="showIosNologinBuyModel" :showConfirmButton="false" :closeOnClickOverlay="true" width="315px">
            <div class='iosNologinBuyModel'>
                <h2>账号未登录</h2>
                <div class='txt'>
                    <p>未登录状态进行购买，会有以下限制</p>
                    <p>1.商品购买后，购买的商品及购买记录无法转移到其他即嗨账号，仅限本设备使用。</p>
                    <p>2.App卸载后，购买的商品无法找回。</p>
                </div>
                <div class='btnGroup'>
                    <span class='goPay' @click="goLogin">去登录购买</span>
                    <span @click="goIosNologinPay">仅在本设备购买</span>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import mutil from "../../../utils/mutil"
import { urlQuery, isStorepack, getAppV, formatNum, isHiscores, isWeiXin, isJHApp, isJHAppios, doLogin, isLogin } from "../../../utils/base"
import jsbridg from '../../../utils/jsbridg'
import { getUser } from "../../../api/model"
import { Dialog } from 'vant';
export default {
    name: "hedaer",
    props: ['behavior', 'type', 'info', 'buyInfo', 'vip'],
    components: {
        [Dialog.Component.name]: Dialog.Component
    },
    data () {
        return {
            showIosNologinBuyModel: false,
            dailyMap: mutil.dailyMap,
            // 数据模型价格
            dataPrice: {
                1: 30,
                2: 30,
                3: 98,
                4: 30,
                5: 30,
                18: 198,
                17: 198,
                16: 198,
                15: 298,
                19: 598,
                20: 298,
                21: 198,
                22: 198
            },
            bindUserInfo: {} // 微信绑定信息
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        this.httpUserInfo();
    },
    mounted () {
        // eslint-disable-next-line eqeqeq
        if (this.type == 20) {
            this.initRaderCard()
        }
    },
    methods: {
        goLogin () {
            this.showIosNologinBuyModel = false
            doLogin();
        },
        goIosNologinPay (renewals) {
            this.showIosNologinBuyModel = false;
            let payUrl = ""
            if (isJHAppios() || !isJHApp()) {
                payUrl = process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=pay_data&type=' + this.type + '&src=' + urlQuery("src");
            } else {
                payUrl = process.env.VUE_APP_DOMAIN + '/user/payment?type=' + this.type + '&src=' + urlQuery("src");
            }
            // if (renewals) {
            //     payUrl += "&renewals=1"
            // }
            if (this.onlineIsAuto && !this.isStorepacks()) {
                Dialog.alert({
                    title: '温馨提示',
                    message: '您已开通了自动续费功能，需要到苹果设备上取消续费后才能再次购买哦~ 取消方法：通过手机【设置】进入【iTunes Store与App Store】>>选择【Apple ID】>>点击【查看Apple ID】>>在账户设置页面点击【订阅管理】>>取消即嗨' + this.dailyMap[this.type + ''] + '的订阅即可。',
                    confirmButtonText: '我知道了',
                    confirmButtonColor: '#646566'
                }).then(() => {
                    // on close
                });
                return;
            }
            if (isJHApp()) {
                if (isJHAppios()) {
                    jsbridg.goWebview({
                        url: payUrl,
                        jumptype: 2
                    });
                } else {
                    window.location.href = payUrl
                }
            } else {
                window.open(payUrl);
            }
        },
        // 跳转模型购买页
        goPay (renewals) {
            // var iosNeedLogin = urlQuery("ios_need_login") * 1 || 0;
            // util.isJHAppios() && !util.isLogin()
            if (this.isJHAppioss() && !isLogin()) {
                this.showIosNologinBuyModel = true;
                return
            // } else if (iosNeedLogin) {
            } else {
                if (!isLogin()) {
                    doLogin();
                    return;
                }
            }
            // // ios商城包自动续费已开通
            if (this.onlineIsAuto && !this.isStorepacks()) {
                Dialog.alert({
                    title: '温馨提示',
                    message: '您已开通了自动续费功能，需要到苹果设备上取消续费后才能再次购买哦~ 取消方法：通过手机【设置】进入【iTunes Store与App Store】>>选择【Apple ID】>>点击【查看Apple ID】>>在账户设置页面点击【订阅管理】>>取消即嗨' + this.dailyMap[this.type + ''] + '的订阅即可。',
                    confirmButtonText: '我知道了',
                    confirmButtonColor: '#646566'
                }).then(() => {
                    // on close
                });
                return;
            }
            let payUrl = ""
            if (isJHAppios() || !isJHApp()) {
                payUrl = process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=pay_data&type=' + this.type + '&src=' + urlQuery("src");
            } else {
                payUrl = process.env.VUE_APP_DOMAIN + '/user/payment?type=' + this.type + '&src=' + urlQuery("src");
            }
            if (renewals) {
                payUrl += "&renewals=1"
            }
            // this.$router.push({
            //     path: url,
            //     query: {
            //         type: 15,
            //         ordertype: 'pay_data'
            //     }
            // })
            if (isJHApp()) {
                if (isJHAppios()) {
                    jsbridg.goWebview({
                        url: payUrl,
                        jumptype: 2
                    });
                } else {
                    window.location.href = payUrl
                }
            } else {
                window.open(payUrl);
            }
        },
        // 雷达卡片
        initRaderCard () {
            // 1. 获取元素
            var focus = document.querySelector('.focus');
            var ul = focus.children[0];
            var ol = focus.children[1];
            // 获得focus的宽度
            var w = focus.offsetWidth;
            // 2. 利用定时器自动轮播图片
            var index = 0;
            var timer = setInterval(function () {
                index++;
                var translateX = -index * w;
                // 添加动画效果
                ul.style.transition = 'all .3s';
                ul.style.transform = 'translateX(' + translateX + 'px)';
            }, 5000);
            // 等着过渡完成之后，再去判断，监听过渡完成的事件transitionend
            ul.addEventListener('transitionend', function () {
                // 无缝滚动
                if (index >= 3) {
                    index = 0;
                    // 去掉过渡效果，这样让ul快速的跳到目标位置
                    ul.style.transition = 'none';
                    // 利用最新的索引号乘以宽度，继续滚动图片
                    var translateX = -index * w;
                    ul.style.transform = 'translateX(' + translateX + 'px)';
                } else if (index < 0) {
                    index = 2;
                    // 去掉过渡效果，这样让ul快速的跳到目标位置
                    ul.style.transition = 'none';
                    // 利用最新的索引号乘以宽度，继续滚动图片
                    // eslint-disable-next-line no-redeclare
                    var translateX = -index * w;
                    ul.style.transform = 'translateX(' + translateX + 'px)';
                }
                // 3. 小圆点跟随变化
                // 把ol里面li带有current类名的选出来，去掉类名remove
                ol.querySelector('.current').classList.remove('current');
                // 让当前索引号的li加上current类名add
                ol.children[index].classList.add('current');
            });
            // 4. 手指滑动轮播图
            // 触摸元素touchstart：获取手指初始坐标
            var startX = 0;
            var moveX = 0; // 后面会使用这个移动距离，所以要定义为全局变量
            var flag = false; // 用来标志手指是否真的移动，还是只是点击
            ul.addEventListener('touchstart', function (e) {
                startX = e.targetTouches[0].pageX;
                // 手指触摸的时候就停止定时器
                clearInterval(timer);
            });
            // 移动手指touchmove：计算手指的滑动距离，并且移动盒子
            ul.addEventListener('touchmove', function (e) {
                // 计算移动距离
                // e.targetTouches[0]为第一个手指，[1]表示第二个手指
                moveX = e.targetTouches[0].pageX - startX;
                // 移动盒子：盒子原来的位置 + 手指移动的距离
                var translateX = -index * w + moveX;
                // 手指拖动的时候，不需要动画效果，所以要取消过渡效果
                ul.style.transition = 'none';
                ul.style.transform = 'translateX(' + translateX + 'px)';
                flag = true;
                e.preventDefault(); // 组织滚动屏幕的行为
            });
            // 手指离开，根据移动距离去判断是回弹还是播放上一张或者下一张
            ul.addEventListener('touchend', function (e) {
                // 只有手指移动过了，才执行下面的代码
                if (flag) {
                    // （1）如果移动距离大于50像素，则播放上一张或者下一张
                    if (Math.abs(moveX) > 50) {
                        // 如果是右滑就是播放上一张，moveX是正值
                        if (moveX > 0) {
                            index--;
                        } else {
                            // 如果是左滑就是播放下一张，moveX是负值
                            index++;
                        }
                        // 用最新的index乘以宽度
                        var translateX = -index * w;
                        ul.style.transition = 'all .3s';
                        ul.style.transform = 'translateX(' + translateX + 'px)';
                    } else {
                        // （2）如果移动距离小于50像素就回弹
                        // eslint-disable-next-line no-redeclare
                        var translateX = -index * w;
                        ul.style.transition = 'all .1s';
                        ul.style.transform = 'translateX(' + translateX + 'px)';
                    }
                }
                // 手指离开的时候就重新开启定时器
                // 注意：开启定时器之前要先清空之前的定时器，保证当前只有一个定时器在执行
                clearInterval(timer);
                timer = setInterval(function () {
                    index++;
                    var translateX = -index * w;
                    // 添加动画效果
                    ul.style.transition = 'all .3s';
                    ul.style.transform = 'translateX(' + translateX + 'px)';
                }, 5000);
            });
        },
        // 是否嗨比分
        isHiscoress () {
            return isHiscores()
        },
        // 是否商城包
        isStorepacks () {
            return isStorepack()
        },
        // 获取版本号
        getAppVs () {
            return getAppV()
        },
        isJHAppioss () {
            return isJHAppios()
        },
        // 是否微信
        isWeixins () {
            return isWeiXin()
        },
        diffDay () {
            // eslint-disable-next-line eqeqeq
            if (this.info.status == 2) {
                // 情报时间精确到时分秒
                // eslint-disable-next-line eqeqeq
                if (this.type == 19) {
                    var standtime = this.info.end_time.replace(/-/g, '/');
                    var diffTime = (new Date(standtime).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24;
                    var difftime = formatNum(diffTime, 2) * 1;
                    var difftime2 = Math.ceil(diffTime);
                    if (difftime < 1) {
                        return "";
                    } else {
                        return "(剩余" + difftime2 + "天)";
                    }
                } else {
                    // eslint-disable-next-line no-redeclare
                    var standtime = this.info.end_time.replace(/-/g, '/');
                    // eslint-disable-next-line no-redeclare
                    var diffTime = (new Date(standtime).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24;
                    // eslint-disable-next-line no-redeclare
                    var difftime = Math.ceil(diffTime);
                    return "(剩余" + difftime + "天)";
                }
            }
        },
        // 去关注服务号
        goFollowServiceHouse () {
            const bindname = this.bindUserInfo.nickname;
            if (this.isWeixins()) {
                // 微信中暂不处理
            } else {
                const serviceUrl = process.env.VUE_APP_H5_DOMAIN + "/page/followservicehouse?bindname=" + bindname;
                if (isJHApp()) {
                    jsbridg.goWebview({
                        url: serviceUrl,
                        jumptype: 2
                    });
                } else {
                    window.open(serviceUrl);
                }
            }
        },
        // 获取用户信息
        async httpUserInfo () {
            const data = await getUser()
            if (data && data.errno === 0) {
                var user = data.data;
                this.bindUserInfo = user.wx;
            }
        }
    }
}
</script>

<style lang="less">
.iosNologinBuyModel{
    width: 100%;
    height: 300px;
    background-color: #fff;
    color: #222;
    padding: 20px;
    h2{
        font-size: 16px;
        text-align: center;
        line-height: 20px;
    }
    .txt{
        margin-top: 20px;
        p{
            font-size: 14px;
            line-height: 20px;
        }
    }
    .btnGroup{
        margin-top: 40px;
        span{
            display: block;
            width: 100%;
            height: 30px;
            line-height: 30px;
            border-radius: 4px;
            border: 1px solid #222;
            font-size: 15px;
            text-align: center;
        }
        .goPay{
            color: #169aff !important;
            border-color: #169aff !important;
            margin-bottom: 15px;
        }
    }
}
.dailyProductDark{
    .iosNologinBuyModel{
        background-color: #191919;
        color: #d3d3d3;
        .btnGroup{
            span{
                color: #d3d3d3;
                border-color: #d3d3d3;
            }
            .goPay{
                color: #169aff !important;
                border-color: #169aff !important;
                margin-bottom: 15px;
            }
        }
    }
}
</style>
